import { module } from 'stereomodularjs';
import { createApp } from "vue/dist/vue.esm-bundler.js"
import ShowListing from '../components/ShowListing.vue';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const self = this;
        if (window.appShows) {
            console.log('Programs already initialized');
            return;
        }
        window.appShows = createApp({
            template: '<ShowListing :block="block" />',
            components: {
                ShowListing
            },
            data() {
                return {}
            },
        })
        window.appShows.config.globalProperties.modu = this;
        window.appShows.mount(self.el)
    }

    destroy() {
        if (window.appShows) {
            window.appShows.unmount();
            delete window.appShows.config.globalProperties.modu;
            delete window.appShows;
        }
    }
}